/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name stoppropogation
 * @description stop propogation of DOM elements
 */
angular.module('mercury.directives.stoppropogation', [])
.directive('stoppropogation', function() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      $(element).bind('click', function(e) {
        e.stopPropagation();
      });
    }
  };
});
